import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "body"
    }}>{`body`}</h1>
    <p><strong parentName="p">{`Since`}</strong>{` UXP v2.0`}</p>
    <p>{`The body element of the plugin. When a plugin has multiple panels, the `}<inlineCode parentName="p">{`<body>`}</inlineCode>{` tag represents the first panel's contents, and additional panels will have a `}<inlineCode parentName="p">{`<uxp-panel>`}</inlineCode>{` element inserted into the DOM to represent their corresponding bodies.`}</p>
    <p><strong parentName="p">{`See`}</strong>{`: `}<a parentName="p" {...{
        "href": "https://developer.mozilla.org/en/docs/Web/HTML/Element/body"
      }}>{`https://developer.mozilla.org/en/docs/Web/HTML/Element/body`}</a></p>
    <p><strong parentName="p">{`Example`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-html"
      }}>{`<body>
    Hello, world
</body>
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      